/**
 * Handles the submission of the custom tenders form.
 *
 * @param {Object} values - The form values with the following properties:
 * @param {string} values.displayName - The display name of the custom tender. Defaults to an empty string if not provided.
 * @param {boolean} values.taxable - Flag indicating if the custom tender is taxable. Defaults to true if not provided.
 * @param {boolean} values.active - Flag indicating if the custom tender is active. Defaults to false if not provided.
 * @param {boolean} values.managerApproval - Flag indicating if manager approval is required. Defaults to false if not provided.
 * @param {boolean} values.noop - A no-operation flag.
 * @param {Array<string>} values.revenueCenters - An array of revenue center UUIDs associated with the custom tender. Determined by the selectedRevenueCenterUUIDs function.
 * @param {string} venueUuid - The unique identifier for the venue.
 * @param {string} uuid - The unique identifier for the custom tender (used in edit mode).
 * @param {string} organizationName - The name of the organization.
 * @param {boolean} isNewCustomTender - Flag indicating if this is a new custom tender creation.
 * @param {Function} onCreateCustomTender - Callback function to be called for creating a new custom tender.
 * @param {Function} onUpdateCustomTender - Callback function to be called for updating an existing custom tender.
 * @returns {Promise} A promise that resolves with the result of the create or update operation.
 */

export const handleCustomTendersFormSubmit = (
  values,
  venueUuid,
  uuid,
  organizationName,
  isNewCustomTender,
  onCreateCustomTender,
  onUpdateCustomTender
) => {
  const additionalData = {
    venueUuid,
    organizationName,
    authorize: true,
  }

  const newCustomTenderData = {
    customPaymentTypes: [{ ...values, ...additionalData }],
  }

  const editCustomTenderData = {
    customPaymentTypes: [{ ...values, ...additionalData, uuid }],
  }

  if (isNewCustomTender) {
    return onCreateCustomTender(newCustomTenderData)
  }

  return onUpdateCustomTender(editCustomTenderData)
}
